import { render, staticRenderFns } from "./SmsOptInPopup.vue?vue&type=template&id=4771bcf6"
import script from "./SmsOptInPopup.vue?vue&type=script&lang=js"
export * from "./SmsOptInPopup.vue?vue&type=script&lang=js"
import style0 from "./SmsOptInPopup.vue?vue&type=style&index=0&id=4771bcf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports